import { useMutation } from '@apollo/client';
import { graphql } from '@gql/gql';
import type { UnsubscribePageFormValues } from '@presentation/pages';
import { useCallback } from 'react';

export const UNSUBSCRIBE_MANAGE_CONTACT_PREFERENCES = graphql(`
  mutation UnsubscribeManageContactPreferences($data: ManageContactPreferencesInput!) {
    manageContactPreferences(data: $data)
  }
`);

export const useManageContactPreferences = () => {
  const [manageContactPreferences, { error, loading }] = useMutation(
    UNSUBSCRIBE_MANAGE_CONTACT_PREFERENCES,
    {
      awaitRefetchQueries: true,
      refetchQueries: [],
    },
  );

  const updateContactPreferences = useCallback(
    (values: UnsubscribePageFormValues) => {
      const { contactPreferences, email } = values;

      return manageContactPreferences({
        variables: { data: { email: String(email), contactPreferences } },
      });
    },
    [manageContactPreferences],
  );

  return {
    updateContactPreferencesLoading: loading,
    updateContactPreferencesError: error,
    updateContactPreferences,
  };
};
